const DEVICE_ONLINE = '/topic/device/online';
const DEVICE_OFFLINE = '/topic/device/offline';
const WEBSOCKET_URL = `${process.env.WEBSOCKET_URL}/sockjs`;
/**
 * 申明和服务器的WebSocket的接口
 */
export default {
  DEVICE_ONLINE,
  DEVICE_OFFLINE,
  WEBSOCKET_URL,
  /**
   * 通道的页状态发生更变.
   * 该协议发回的数据结构：
   * {
   *   canConfigId:'123',
   *   page:0
   * }
   * @param canConfigId
   * @return {string}
   */
  canPageStateChanged(canConfigId) {
    return `/topic/can/${canConfigId}/page/state`;
  },
  /**
   * 订阅某面板数据
   * @param panelId
   * @return {string}
   */
  panelData: panelId => `/queue/panel/data/${panelId}`,
  /**
   * 面板开启的ack
   * 该协议发回的数据结构：
   * {
   *  panelId:'123',
   *  success:true,
   *  data:[
   *    {
   *      canConfigId:'123',
   *      page:1
   *    }
   *  ]
   *  }
   * @param panelId
   * @return {string}
   */
  panelStartAck(panelId) {
    return `/topic/panel/ack/${panelId}`;
  },
  /**
   * 工程面板启动ack
   * author: wkb
   * @param projectId
   * @returns {string}
   */
  projectStartAck(projectId) {
    return `/topic/project/ack/${projectId}`;
  },
  udsFeedback(panelId) {
    return `/topic/panel/uds/${panelId}`;
  },
  /**
   * 文件下载到设备的ACK
   * @param fileId
   * @return {string}
   */
  fileDownloadToDeviceAck(fileId) {
    return `/topic/file/downloadToDeviceAck/${fileId}`;
  },
  /**
   * 设备上的文件，上传到服务器后的ACK
   * @param fileId
   * @return {string}
   */
  deviceFileUploadToServerAck(fileId) {
    return `/topic/file/uploadToServerAck/${fileId}`;
  },
  brushFinishedAck(deviceId, canIndex) {
    return `/topic/device/brushFinished/${deviceId}/${canIndex}`;
  },
  /**
   * 订阅OTA数据
   * @param deviceId
   * @return {String}
   */
  otaProgress(deviceId) {
    return `/queue/ota/data/${deviceId}`;
  },
  /**
   * 订阅OTA错误报告
   * @param deviceId
   * @param canIndex
   * @returns {string}
   */
  otaErrorMsg(deviceId, canIndex) {
    return `/topic/ota/${deviceId}/${canIndex}/errorMsg`;
  },
  /**
   * 订阅文件上传进度条
   * @param fileId
   * @return {String}
   */
  fileUploadProgress(fileId) {
    return `/queue/fileUpload/progress/${fileId}`;
  },
  /**
   * 订阅文件自动上传或批量上传，返回实施正在上传的id
   * @param deviceId
   * @returns {string}
   */
  autoFileUploadStatus(deviceId) {
    return `/topical/device/file_upload/status/${deviceId}`;
  },
  /**
   * 订阅发送应答
   * @param projectId
   * @return {String}
   */
  sendAck(projectId) {
    return `/queue/project/sendAck/${projectId}`;
  },
  /**
   * 订阅标定初始值
   * @param projectId
   * @return {String}
   */
  bindIniValue(projectId) {
    return `/topic/project/InitValue/${projectId}`;
  },
};



// WEBPACK FOOTER //
// ./src/api/websocketApi.js